import axios from 'axios';
import {
  CreateTimelinePostRequest,
  CreateTimelinePostResponse,
  UpdateTimelinePostRequest,
  GetTimelinePostsQuery,
  GetTimelinePostsResponse,
  GetTimelinePostResponse,
  LikePostResponse,
  DeleteTimelinePostResponse,
  CompanyPostStatsResponse,
} from '../types/timeline';

export const timelineService = {
  // 投稿作成（企業管理者・人事のみ）
  createPost: async (
    postData: CreateTimelinePostRequest
  ): Promise<CreateTimelinePostResponse> => {
    const response = await axios.post('/api/timeline/posts', postData, {
      withCredentials: true,
    });
    return response.data;
  },

  // 投稿更新（企業管理者・人事のみ）
  updatePost: async (
    postId: number,
    updateData: UpdateTimelinePostRequest
  ): Promise<CreateTimelinePostResponse> => {
    const response = await axios.put(
      `/api/timeline/posts/${postId}`,
      updateData,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 投稿一覧取得（全ユーザー）
  getPosts: async (
    query: GetTimelinePostsQuery = {}
  ): Promise<GetTimelinePostsResponse> => {
    const params = new URLSearchParams();

    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());
    if (query.category) params.append('category', query.category);
    if (query.categories && query.categories.length > 0) {
      query.categories.forEach(category => params.append('categories', category));
    }
    if (query.status) params.append('status', query.status);
    if (query.company_id)
      params.append('company_id', query.company_id.toString());
    if (query.search) params.append('search', query.search);

    const response = await axios.get(
      `/api/timeline/posts?${params.toString()}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 投稿詳細取得（全ユーザー）
  getPostById: async (postId: number): Promise<GetTimelinePostResponse> => {
    const response = await axios.get(`/api/timeline/posts/${postId}`, {
      withCredentials: true,
    });
    return response.data;
  },

  // いいね追加・削除（学生のみ）
  toggleLike: async (postId: number): Promise<LikePostResponse> => {
    const response = await axios.post(
      `/api/timeline/posts/${postId}/like`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 投稿削除（企業管理者・人事のみ）
  deletePost: async (postId: number): Promise<DeleteTimelinePostResponse> => {
    const response = await axios.delete(`/api/timeline/posts/${postId}`, {
      withCredentials: true,
    });
    return response.data;
  },

  // 企業投稿統計取得（企業ユーザーのみ）
  getCompanyStats: async (
    companyId: number
  ): Promise<CompanyPostStatsResponse> => {
    const response = await axios.get(
      `/api/timeline/companies/${companyId}/stats`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  // 画像アップロード（企業ユーザーのみ）
  uploadImage: async (file: File): Promise<{ data: { image_url: string } }> => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post('/api/timeline/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    // レスポンス形式を統一
    return {
      data: {
        image_url: response.data.data.image_url,
      },
    };
  },
};
